module.exports = __webpack_public_path__ + "static/DoubleDiamond-ae81a9dbd239d1c1cad87982ad8bbc01.png";